import type { ScreenModule } from "../../../app/screen-module";
import { StoragePage } from "../WorkspacePages";

export default {
	id: "end-user.storage",
	path: "/app/storage",
	area: "end-user",
	navGroup: "",
	navIcon: "storage",
	label: "ストレージ",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: StoragePage,
} satisfies ScreenModule;
